var data = {
    sections: ["About",
    "Experience",
    "Education",
    "Current Projects",
    "Past Projects",
    "This Page",
    "Contact",
],
}

export default data;